/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Integrations_Sales_NoteInputs */

const tr_landing_integrations_sales_note = /** @type {(inputs: Landing_Integrations_Sales_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazaryerleri ve kendi mağazanız aynı panelde. Bir kanalda satılan ürün, stoktan her yerde aynı anda düşer.`)
};

const en_landing_integrations_sales_note = /** @type {(inputs: Landing_Integrations_Sales_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplaces and your own store in one panel. Sell on any channel and stock drops everywhere at once.`)
};

const de_landing_integrations_sales_note = /** @type {(inputs: Landing_Integrations_Sales_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktplätze und Ihr eigener Shop in einem Panel. Verkauft sich etwas auf einem Kanal, sinkt der Bestand überall gleichzeitig.`)
};

const ru_landing_integrations_sales_note = /** @type {(inputs: Landing_Integrations_Sales_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маркетплейсы и ваш магазин в одной панели. Продажа в любом канале списывает остаток везде сразу.`)
};

/**
* | output |
* | --- |
* | "Marketplaces and your own store in one panel. Sell on any channel and stock drops everywhere at once." |
*
* @param {Landing_Integrations_Sales_NoteInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_integrations_sales_note = /** @type {((inputs?: Landing_Integrations_Sales_NoteInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Integrations_Sales_NoteInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_integrations_sales_note(inputs)
	if (locale === "de") return de_landing_integrations_sales_note(inputs)
	if (locale === "ru") return ru_landing_integrations_sales_note(inputs)
	return tr_landing_integrations_sales_note(inputs)
});